import { cx } from './cx.ts'

export type OptionProps = {
  name: string
  value: string
  label: string
  emoji?: string
  checked: boolean
  onChange: (value: string) => void
}

/**
 * Figma: `Option` (64 px, radius 16, Body/Strong). Karta odpowiedzi kwalifikatora = natywny radio
 * (grupa po `name`); zaznaczona = violet ramka 2 px + tło selected-soft + violet tekst.
 * Hover = jasnofioletowa ramka, active = scale(.99) — jak `.tk-opt` na step.tutlo.com.pl. Auto-advance robi rodzic w `onChange`.
 */
export function Option({ name, value, label, emoji, checked, onChange }: OptionProps) {
  return (
    <label
      className={cx(
        'flex min-h-16 cursor-pointer items-center gap-md rounded-card px-base py-md text-body-strong transition-[border-color,background-color,transform] duration-150 active:scale-[0.99] has-focus-visible:outline-2 has-focus-visible:outline-offset-2 has-focus-visible:outline-selected',
        checked
          ? 'border-2 border-selected bg-selected-soft text-selected'
          : 'border-[1.5px] border-border bg-bg-card text-text-primary hover:border-selected-line',
      )}
    >
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        className="sr-only"
      />
      {emoji ? (
        <span aria-hidden="true" className="text-[22px] leading-none">
          {emoji}
        </span>
      ) : null}
      <span>{label}</span>
    </label>
  )
}
